"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSession = exports.fetchSessionByBuilderId = exports.createSession = exports.fetchSessions = exports.DOC_TYPE = void 0;
const apiFetch_1 = require("../utils/apiFetch");
const API_BASE = process.env.WITHOUT_GATEWAY
    ? process.env.REACT_APP_TEMPLATE_BUILDER_URL
    : `${process.env.REACT_APP_API_BASE_URL}/v1/template-builder`;
var DOC_TYPE;
(function (DOC_TYPE) {
    DOC_TYPE["FORM"] = "form";
    DOC_TYPE["PPT"] = "ppt";
    DOC_TYPE["WORD"] = "word";
    DOC_TYPE["PDF"] = "pdf";
})(DOC_TYPE || (exports.DOC_TYPE = DOC_TYPE = {}));
const fetchSessions = (_a) => __awaiter(void 0, [_a], void 0, function* ({ search = "", docType = "", sortField = "createdAt", sortOrder = "desc", page = 1, // backend is 1-indexed
limit = 10, }) {
    console.log("fetchSessions Is running");
    // Build query params
    const params = new URLSearchParams();
    if (search)
        params.append("search", search);
    if (docType)
        params.append("doc_type", docType);
    if (sortField)
        params.append("sortField", sortField);
    if (sortOrder)
        params.append("sortOrder", sortOrder);
    if (page)
        params.append("page", page.toString());
    if (limit)
        params.append("limit", limit.toString());
    console.log("fetchSessions params", params.toString(), API_BASE);
    const response = yield (0, apiFetch_1.apiFetch)(`${API_BASE}/builder?${params.toString()}`, {
        method: "GET",
    });
    return response;
});
exports.fetchSessions = fetchSessions;
const createSession = (docType, templateId, sessionName, isTemplate) => __awaiter(void 0, void 0, void 0, function* () {
    const body = {
        name: sessionName || "Test Session",
        docType,
        isTemplate: isTemplate || false
    };
    if (templateId) {
        body.templateId = templateId.toString();
    }
    return (0, apiFetch_1.apiFetch)(`${API_BASE}/builder`, {
        method: "POST",
        body: JSON.stringify(body),
    });
});
exports.createSession = createSession;
const fetchSessionByBuilderId = (builderId) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, apiFetch_1.apiFetch)(`${API_BASE}/builder/${builderId}`, {
        method: "GET",
    });
});
exports.fetchSessionByBuilderId = fetchSessionByBuilderId;
const updateSession = (sessionId, updatedData) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, apiFetch_1.apiFetch)(`${API_BASE}/builder/${sessionId}`, {
        method: "PATCH",
        body: JSON.stringify(updatedData),
    });
});
exports.updateSession = updateSession;
